"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Hsb(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M20 4c1.103 0 2 .897 2 2v12c0 1.103-.897 2-2 2H4c-1.103 0-2-.897-2-2V6c0-1.103.897-2 2-2zm0 2H4v12h16.002L20 6zm-7.753 3.443c.357 0 .68.064.962.192.284.128.505.309.661.545.158.236.236.506.236.808H12.91c0-.203-.063-.36-.187-.471-.124-.112-.292-.167-.503-.167-.214 0-.384.046-.508.141a.436.436 0 0 0-.186.361c0 .127.07.243.205.346.137.104.377.211.721.322.344.11.627.229.848.357.538.31.806.737.806 1.281 0 .436-.164.778-.492 1.026-.328.249-.778.373-1.35.373-.404 0-.768-.073-1.095-.217-.327-.145-.574-.343-.739-.595a1.553 1.553 0 0 1-.248-.87h1.204c0 .267.07.463.207.59.137.126.361.189.671.189.198 0 .355-.043.47-.128a.424.424 0 0 0 .173-.36.49.49 0 0 0-.187-.41c-.124-.099-.342-.2-.655-.305a6.088 6.088 0 0 1-.765-.305c-.645-.316-.967-.751-.967-1.304 0-.277.08-.52.241-.731a1.55 1.55 0 0 1 .682-.492 2.66 2.66 0 0 1 .991-.176zm-5.625.068v1.976H8.39V9.511h1.192v4.977H8.39V12.41H6.622v2.078h-1.2V9.511h1.2zm9.889.001c.64 0 1.127.117 1.46.351.335.236.5.576.5 1.023 0 .258-.058.477-.177.659a1.037 1.037 0 0 1-.522.404c.259.069.459.195.598.383.139.187.208.414.208.684 0 .487-.154.853-.463 1.098-.308.245-.766.369-1.372.374h-2.02V9.512h1.788zm.252 2.861h-.84v1.192h.785c.217 0 .383-.049.5-.148a.526.526 0 0 0 .174-.419c0-.415-.206-.623-.62-.625zm-.252-1.938h-.588v1.151h.625c.262-.002.449-.05.56-.144.112-.093.169-.231.169-.415 0-.21-.061-.361-.182-.454-.121-.093-.316-.138-.584-.138z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Hsb;
